import { combineReducers } from 'redux';

import types from './types';

import TrackingModel from 'src/model/trackingInfo.model';
import { Moment } from 'moment';
import { totalElementsSel } from '../pagination';

const content = (
  state: TrackingModel[] = [],
  { type, payload }: { type: string; payload: TrackingModel[] }
) => {
  switch (type) {
    case types.CLEAR_ALL:
      return [];
    case types.SET_CONTENT:
      return payload;

    default:
      return state;
  }
};

const getTrackingIsPending = (
  state: boolean = false,
  { type, payload }: { type: string; payload: any }
) => {
  switch (type) {
    case types.GET_TRACKING_IS_PENDING:
      return payload;

    default:
      return state;
  }
};

const datesFilter = (
  state: { start: Moment | null; end: Moment | null } | null = null,
  {
    type,
    payload
  }: {
    type: string;
    payload: { start: Moment | null; end: Moment | null } | null;
  }
) => {
  switch (type) {
    case types.SET_DATES_FILTER:
      return payload;

    default:
      return state;
  }
};

const error = (
  state: { caller: string; error: any } = { caller: '', error: null },
  { type, payload }: { type: string; payload: any }
) => {
  switch (type) {
    case types.TRACKING_ERROR:
      return payload;

    default:
      return state;
  }
};

const pagination = (
  state: {
    pageNumber: number;
    pageSize: number;
    totalElements: number;
    totalPages: number;
  } = { pageNumber: 0, pageSize: 0, totalElements: 0, totalPages: 0 },
  { type, payload }: { type: string; payload: any }
) => {
  switch (type) {
    case types.TRACKING_PAGINATION:
      return payload;

    default:
      return state;
  }
};

export default combineReducers({
  content,
  getTrackingIsPending,
  datesFilter,
  error,
  pagination
});
